const Action = {
  ERROR: "Error",
  LOGIN: "login",
  LOGOUT: "LOGOUT",
  SIGNUP: "signup",
  DISSMISS: "dismiss",

  ALL_FOODS: "view_all",
  TOP_RESTAURANTS: "top_restaurants",
  VIEW_CART: "view_cart",
  VIEW_ORDER: "view_Order",
  CREATE_ORDER: "create_Order",
  ORDER_DETAILS: "order_details",
};

export default Action;
